import {createContext, useMemo, useState} from "react";
import {Outlet} from "react-router-dom";

export const FindVinFormDataContext = createContext({});

export const FindVinFormDataProvider = () => {
    const [vinFieldValue, setVinFieldValue] = useState('');
    const [engineCC, setEngineCC] = useState('');
    const [year, setYear] = useState(null);

    const contextValue = useMemo(() => ({
        vinFieldValue,
        setVinFieldValue,
        engineCC,
        setEngineCC,
        year,
        setYear,
    }), [vinFieldValue, setVinFieldValue, engineCC, setEngineCC, year, setYear]);

    return <FindVinFormDataContext.Provider value={contextValue}>
        <Outlet />
    </FindVinFormDataContext.Provider>
};